import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';
import { DrawCode } from '../models/draw-codes.models';

@Injectable({
  providedIn: 'root'
})
export class DrawCodesService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  createDrawCode(drawCode: Omit<DrawCode, 'id'>): Observable<DrawCode> {
    return this.#http.postData(`${this.baseUrl}/drawcode`, { showLoader: true, showMessage: true }, drawCode);
  }

  readDrawCodes(): Observable<DrawCode[]> {
    return this.#http.getData(`${this.baseUrl}/drawcode`, { showLoader: true, showMessage: false });
  }

  readDrawCodeById(id: string): Observable<DrawCode> {
    return this.#http.getData(`${this.baseUrl}/drawcode/${id}`, { showLoader: true, showMessage: false });
  }

  updateDrawCode(drawCode: Omit<DrawCode, 'id'>, id: string): Observable<any> {
    return this.#http.putData(`${this.baseUrl}/drawcode/${id}`, drawCode, { showLoader: true, showMessage: true });
  }

  deleteDrawCode(id: string): Observable<any> {
    return this.#http.deleteData(`${this.baseUrl}/drawcode/${id}`, { showLoader: true, showMessage: true });
  }
}
